import styled, { css } from 'styled-components';
import { CustomLink } from '../../../CustomLink';
import {
  FlexBetween,
  FlexCenterAligned,
  arrow,
  ellipsisText
} from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { CurrentItemTitle } from '../CurrentItemDesc/styled';
import { ReportSectionContainer } from '../ReportSection/styled';
import { BookmarkArea, BookmarkContainer } from '../../../Bookmark/styled';

export const TitleContentWrapper = styled(FlexBetween)`
  width: 100%;
  gap: 15px;
`;

export const TitleWrapper = styled.div<{ $hideOnMobile: boolean }>`
  width: 100%;
  ${({ $hideOnMobile }) =>
    $hideOnMobile &&
    css`
      @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
        display: none;
      }
    `}
`;

export const Title = styled(FlexCenterAligned)<{
  $isFixed: boolean;
  $isPhotosGrid: boolean;
}>`
  min-height: 85px;
  padding: 15px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  width: 100%;
  box-sizing: border-box;
  transition: border-bottom-color 0.3s ease;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 15px 40px;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    padding: 15px 20px;
  }

  ${({ $isFixed }) =>
    $isFixed
      ? css`
          position: fixed;
          top: 0;
          left: 0;
          z-index: 70000;
          opacity: 1;
          border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};

          ${TitleContentWrapper} {
            @media screen and (min-width: ${Breakpoints.desktop}px) {
              max-width: 1000px;
              margin: 0 auto;
              padding: 0 20px;
            }
          }
        `
      : css`
          border-bottom-color: transparent;
        `}

  ${({ $isPhotosGrid }) =>
    $isPhotosGrid &&
    css`
      position: sticky;
      top: 0;
      padding: 10px 47px 10px 0;

      @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
        min-height: 60px;

        ${CurrentItemTitle} {
          margin: 0;
          ${ellipsisText};
        }
      }

      @media screen and (min-width: ${Breakpoints.tablet}px) {
        padding: 22px 40px;
      }

      @media screen and (min-width: ${Breakpoints.desktop}px) {
        padding: 22px 0;
      }
    `}
`;

export const TitleContainer = styled(FlexCenterAligned)`
  gap: 10px;
  flex: 1;
  min-width: 0;

  ${CurrentItemTitle} {
    width: 100%;
  }
`;

export const ActionsContainer = styled(FlexCenterAligned)`
  gap: 15px;
  flex-shrink: 0;
`;

export const Action = styled.div`
  width: 22px;
  height: 22px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    height: 54px;
    width: 54px;
    border-radius: 14px;
    background-color: ${({ theme }) => theme.colors.background.tertiary};

    ${ReportSectionContainer} {
      background-color: ${({ theme }) => theme.colors.background.tertiary};
      border-radius: 14px;
    }
  }
`;

export const BookmarkAction = styled(Action)`
  position: relative;
  cursor: pointer;

  ${BookmarkContainer} {
    width: 100%;
    height: 100%;

    ${BookmarkArea} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  svg {
    fill: transparent;
  }

  @media (hover: hover) {
    &:hover {
      svg path {
        stroke: ${({ theme }) => theme.colors.systemColors.autumnRed};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    position: absolute;
    right: 15px;
  }
`;

export const tooltipStyles = css`
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 23px 20px;
  border-radius: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  right: 0;
  transform: translate(0, 0);
  left: unset;
  width: max-content;
`;

export const BackButton = styled.button`
  vertical-align: middle;
  white-space: nowrap;
  background-position: left 15px center;
  width: 45px;
  height: 45px;
  background: transparent;
  padding: 10px 15px;
  text-align: left;
  cursor: pointer;

  ${({ theme }) =>
    arrow({
      size: '12px',
      fill: theme.colors.text.secondary,
      bw: '2px',
      angle: '135deg',
      indent: '5px'
    })};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    width: 25px;
  }
`;

export const StyledLogoLink = styled(CustomLink)<{ $visible: boolean }>`
  ${FlexCenterAligned};
  width: ${({ $visible }) => ($visible ? '32px' : '0')};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  overflow: hidden;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transform: ${({ $visible }) =>
    $visible ? 'translateY(0) scale(1)' : 'translateY(-6px) scale(0.9)'};
  transition:
    width 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: width, opacity, transform;

  rect {
    transition: all 0.2s ease-in-out;
  }

  @media (hover: hover) {
    &:hover {
      rect {
        fill: #7c4c33;
      }
    }
  }
`;
